import Api from '@/vuex/api'
import { app } from '@/main'
import {
  CLOSE_REPORT,
  CONVERT_TRADES_REPORT,
  CURRENT_REPORT_SEARCH,
  DELETE_REPORT,
  DELETE_TAX_INVOICE_REQUEST,
  DUPLICATE_ASBESTOS_REPORT,
  DUPLICATE_DEFECTS_REPORT,
  DUPLICATE_ESM_REPORT,
  DUPLICATE_INCIDENT_REPORT,
  DUPLICATE_INSPECTION_REPORT,
  DUPLICATE_INSURANCE_REPORT,
  DUPLICATE_OHS_REPORT,
  DUPLICATE_PROPERTY_PHOTOS_REPORT,
  DUPLICATE_TAX_INVOICE_REQUEST,
  GENERATE_ASBESTOS_PDF,
  GENERATE_DEFECTS_PDF,
  GENERATE_ESM_PDF,
  GENERATE_INCIDENT_PDF,
  GENERATE_INSPECTION_PDF,
  GENERATE_INSURANCE_PDF,
  GENERATE_OHS_PDF,
  GENERATE_PROPERTY_PHOTOS_PDF,
  GENERATE_TRADES_PDF,
  GET_IN_USE_REPORTS,
  IN_USE_REPORTS,
  INVOICE_STATUS_OCMANAGER,
  LOAD_REPORTS,
  LOAD_ACTIVE_DATES,
  OPEN_MODAL,
  SEND_ASBESTOS_REPORT,
  SEND_DEFECTS_REPORT,
  SEND_ESM_REPORT,
  SEND_INCIDENT_REPORT,
  SEND_INSPECTION_REPORT,
  SEND_INSURANCE_REPORT,
  SEND_OHS_REPORT,
  SEND_PROPERTY_PHOTOS_REPORT,
  SEND_TAX_INVOICE_REQUEST,
  COMPLETE_TAX_INVOICE_REQUEST,
  SEND_TRADES_REPORT,
  SUBMIT_FORM,
  UPLOAD_DEFECTS_PDF,
  UPLOAD_INCIDENT_PDF,
  UPLOAD_INSPECTION_PDF,
  UPLOAD_INVOICE,
  UPLOAD_OHS_PDF,
  UPLOAD_TRADES_REPORT
} from '@/vuex/types'

const api = new Api()

const state = {
  reports: {
    permalink: false,
    rows: [],
    noResults: '',
    offset: 0,
    limit: 10,
    searchForm: {
      fields: []
    }
  },
  inUseReports: [],
  activeDates: [],
  currentReportSearch: {}
}

const getters = {
  loadedReports ({ reports }) {
    return reports
  },
  inUseReports ({ inUseReports }) {
    return inUseReports
  },
  loadedActiveDates ({ activeDates }) {
    return activeDates
  },
  reportsSearchForm ({ reports }) {
    // This function returns total number of fields.
    // Since, fields is an array of different fields of Report searchForm.
    // So, whatever fields over there, we are going to add one more field named as Limit. (One field is represented by a JSON object)
    return reports.searchForm.fields.concat([{
      name: 'limit',
      label: 'Limit per page',
      type: 'search',
      value: reports.limit,
      fullWidth: true
    }])
  }
}

const mutations = {
  [IN_USE_REPORTS] (context, reports) {
    context.inUseReports = reports
  },
  [LOAD_REPORTS] (context, reports) {
    context.reports = reports
  },
  [LOAD_ACTIVE_DATES] (context, activeDates) {
    context.activeDates = activeDates
  },
  [CURRENT_REPORT_SEARCH] (context, options) {
    context.currentReportSearch = options
  }
}

const actions = {
  async [LOAD_ACTIVE_DATES] (context, options) {
    let data = await api.getActiveReportDates(options)
    context.commit(LOAD_ACTIVE_DATES, data.dates ? data.dates : [])
  },
  async [GET_IN_USE_REPORTS] (context) {
    let data = await api.getInUseReports()
    context.commit(IN_USE_REPORTS, data)
  },
  async [LOAD_REPORTS] (context, options) {
    if (!options) {
      options = context.state.currentReportSearch
    }
    let data = await api.getReports(options)
    context.commit(LOAD_REPORTS, data)
    context.commit(CURRENT_REPORT_SEARCH, options)
  },
  
  async [CLOSE_REPORT] (context, openReportUuid) {
    let data = await api.closeReport(openReportUuid)
    context.commit(IN_USE_REPORTS, data)
  },
  [UPLOAD_INVOICE] (context, taxInvoiceRequestUuid) {
    let uploadInvoiceModal = {
      permalink: 'uploadInvoice',
      options: {
        title: 'Upload Invoice',
        actionLabel: 'Upload'
      },
      params: {
        taxInvoiceRequestUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadInvoiceModal)
  },
  [DELETE_REPORT] (context, payload) {
    let deleteReportModal = {
      permalink: 'deleteReport',
      options: {
        title: 'Confirm Delete',
        actionLabel: 'Delete'
      },
      params: {
        reportUuid: payload.reportUuid,
        reportType: payload.reportType
      }
    }
    context.dispatch(OPEN_MODAL, deleteReportModal)
  },
  async [INVOICE_STATUS_OCMANAGER] (context, options) {
    await api.setInvoiceStatusOCManager(options)
  },
  async [GENERATE_ASBESTOS_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateAsbestosReportPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          AsbestosReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateAsbestosReportPdf',
        AsbestosReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_DEFECTS_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateDefectsReportPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          DefectsReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateDefectsReportPdf',
        DefectsReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_ESM_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateEsmReportPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          EsmReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateEsmReportPdf',
        EsmReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_INCIDENT_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateIncidentPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          IncidentReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateIncidentPdf',
        IncidentReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_INSPECTION_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateInspectionPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          InspectionReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateInspectionPdf',
        InspectionReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_INSURANCE_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateInsurancePdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          InsuranceReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateInsurancePdf',
        InsuranceReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_OHS_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateOhsReportPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          OhsReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateOhsReportPdf',
        OhsReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_PROPERTY_PHOTOS_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generatePropertyPhotosPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          PropertyPhotosReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generatePropertyPhotosPdf',
        PropertyPhotosReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  async [GENERATE_TRADES_PDF] (context, report) {
    if (report.ReportPdfUuid) {
      let generateReportPdf = {
        permalink: 'generateTradesPdf',
        options: {
          title: 'Confirm Overwrite',
          actionLabel: 'Generate'
        },
        params: {
          TradesReportUuid: report.uuid
        }
      }
      context.dispatch(OPEN_MODAL, generateReportPdf)
    } else {
      let formData = {
        permalink: 'generateTradesPdf',
        TradesReportUuid: report.uuid
      }
      await context.dispatch(SUBMIT_FORM, { data: formData })
    }
  },
  [UPLOAD_DEFECTS_PDF] (context, DefectsReportUuid) {
    let uploadPdfModal = {
      permalink: 'uploadDefectsPdf',
      options: {
        title: 'Upload PDF',
        actionLabel: 'Upload'
      },
      params: {
        DefectsReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadPdfModal)
  },
  [UPLOAD_INCIDENT_PDF] (context, IncidentReportUuid) {
    let uploadPdfModal = {
      permalink: 'uploadIncidentPdf',
      options: {
        title: 'Upload PDF',
        actionLabel: 'Upload'
      },
      params: {
        IncidentReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadPdfModal)
  },
  [UPLOAD_INSPECTION_PDF] (context, InspectionReportUuid) {
    let uploadPdfModal = {
      permalink: 'uploadInspectionPdf',
      options: {
        title: 'Upload PDF',
        actionLabel: 'Upload'
      },
      params: {
        InspectionReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadPdfModal)
  },
  [UPLOAD_OHS_PDF] (context, OhsReportUuid) {
    let uploadPdfModal = {
      permalink: 'uploadOhsPdf',
      options: {
        title: 'Upload PDF',
        actionLabel: 'Upload'
      },
      params: {
        OhsReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadPdfModal)
  },
  [UPLOAD_TRADES_REPORT] (context, TradesReportUuid) {
    let uploadPdfModal = {
      permalink: 'uploadTradesPdf',
      options: {
        title: 'Upload PDF',
        actionLabel: 'Upload'
      },
      params: {
        TradesReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadPdfModal)
  },
  [SEND_ASBESTOS_REPORT] (context, AsbestosReportUuid) {
    let sendModal = {
      permalink: 'sendAsbestosReportEmail',
      options: {
        title: 'Send Asbestos Report',
        actionLabel: 'Send'
      },
      params: {
        AsbestosReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_DEFECTS_REPORT] (context, DefectsReportUuid) {
    let sendModal = {
      permalink: 'sendDefectsReportEmail',
      options: {
        title: 'Send Defects Report',
        actionLabel: 'Send'
      },
      params: {
        DefectsReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_ESM_REPORT] (context, EsmReportUuid) {
    let sendModal = {
      permalink: 'sendEsmReportEmail',
      options: {
        title: 'Send ESM Report',
        actionLabel: 'Send'
      },
      params: {
        EsmReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_INCIDENT_REPORT] (context, IncidentReportUuid) {
    let sendModal = {
      permalink: 'sendIncidentReportEmail',
      options: {
        title: 'Send Incident Report',
        actionLabel: 'Send'
      },
      params: {
        IncidentReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_INSPECTION_REPORT] (context, InspectionReportUuid) {
    let sendModal = {
      permalink: 'sendInspectionReportEmail',
      options: {
        title: 'Send Inspection Report',
        actionLabel: 'Send'
      },
      params: {
        InspectionReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_INSURANCE_REPORT] (context, InsuranceReportUuid) {
    let sendModal = {
      permalink: 'sendInsuranceReportEmail',
      options: {
        title: 'Send Insurance Report',
        actionLabel: 'Send'
      },
      params: {
        InsuranceReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_OHS_REPORT] (context, OhsReportUuid) {
    let sendModal = {
      permalink: 'sendOhsReportEmail',
      options: {
        title: 'Send OH&S Report',
        actionLabel: 'Send'
      },
      params: {
        OhsReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_PROPERTY_PHOTOS_REPORT] (context, PropertyPhotosReportUuid) {
    let sendModal = {
      permalink: 'sendPropertyPhotosReportEmail',
      options: {
        title: 'Send Property Photos Report',
        actionLabel: 'Send'
      },
      params: {
        PropertyPhotosReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [SEND_TRADES_REPORT] (context, TradesReportUuid) {
    let sendModal = {
      permalink: 'sendTradesReportEmail',
      options: {
        title: 'Send Trades Request',
        actionLabel: 'Send'
      },
      params: {
        TradesReportUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  async [CONVERT_TRADES_REPORT] (context, TradesReportUuid) {
    let newReportUuid = await api.convertTradesReport(TradesReportUuid)
    app.$router.push('/trades/edit/' + newReportUuid)
  },
  async [DUPLICATE_ASBESTOS_REPORT] (context, AsbestosReportUuid) {
    let newReportUuid = await api.duplicateAsbestosReport(AsbestosReportUuid)
    app.$router.push('/asbestos-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_DEFECTS_REPORT] (context, DefectsReportUuid) {
    let newReportUuid = await api.duplicateDefectsReport(DefectsReportUuid)
    app.$router.push('/building-defect-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_ESM_REPORT] (context, EsmReportUuid) {
    let newReportUuid = await api.duplicateEsmReport(EsmReportUuid)
    app.$router.push('/esm-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_INCIDENT_REPORT] (context, IncidentReportUuid) {
    let newReportUuid = await api.duplicateIncidentReport(IncidentReportUuid)
    app.$router.push('/247-incident-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_INSPECTION_REPORT] (context, InspectionReportUuid) {
    let newReportUuid = await api.duplicateInspectionReport(InspectionReportUuid)
    app.$router.push('/inspection-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_INSURANCE_REPORT] (context, InsuranceReportUuid) {
    let newReportUuid = await api.duplicateInsuranceReport(InsuranceReportUuid)
    app.$router.push('/insurance-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_OHS_REPORT] (context, OhsReportUuid) {
    let newReportUuid = await api.duplicateOhsReport(OhsReportUuid)
    app.$router.push('/ohs-reports/edit/' + newReportUuid)
  },
  async [DUPLICATE_PROPERTY_PHOTOS_REPORT] (context, PropertyPhotosReportUuid) {
    let newReportUuid = await api.duplicatePropertyPhotosReport(PropertyPhotosReportUuid)
    app.$router.push('/property-photos/edit/' + newReportUuid)
  },
  async [DUPLICATE_TAX_INVOICE_REQUEST] (context, TaxInvoiceRequestUuid) {
    let newRequestUuid = await api.duplicateTaxInvoiceRequest(TaxInvoiceRequestUuid)
    app.$router.push('/tax-invoice-requests/edit/' + newRequestUuid)
  },
  [COMPLETE_TAX_INVOICE_REQUEST] (context, TaxInvoiceRequestUuid) {
    let modal = {
      permalink: 'completeTaxInvoiceRequest',
      options: {
        title: 'Complete Tax Invoice Request',
        actionLabel: 'Complete'
      },
      params: {
        TaxInvoiceRequestUuid
      }
    }
    context.dispatch(OPEN_MODAL, modal)
  },
  [SEND_TAX_INVOICE_REQUEST] (context, TaxInvoiceRequestUuid) {
    let sendModal = {
      permalink: 'sendTaxInvoiceRequest',
      options: {
        title: 'Send Tax Invoice Request',
        actionLabel: 'Send'
      },
      params: {
        TaxInvoiceRequestUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  [DELETE_TAX_INVOICE_REQUEST] (context, TaxInvoiceRequestUuid) {
    let deleteModal = {
      permalink: 'deleteTaxInvoiceRequest',
      options: {
        title: 'Delete Tax Invoice Request',
        actionLabel: 'Delete'
      },
      params: {
        TaxInvoiceRequestUuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteModal)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}




// WEBPACK FOOTER //
// ./src/vuex/modules/reports.js